module.exports = __webpack_public_path__ + "static/img/download.13a4c389.svg";